import { render } from "./savings.vue?vue&type=template&id=d08fabba&scoped=true"
import script from "./savings.vue?vue&type=script&lang=js"
export * from "./savings.vue?vue&type=script&lang=js"

import "./savings.vue?vue&type=style&index=0&id=d08fabba&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d08fabba"

export default script